export { default } from './RecoveryStep2';
